














import { defineComponent, onBeforeUnmount, onMounted, ref, computed } from "@vue/composition-api";
import { ValidationProvider as VeeValidationProvider } from "vee-validate";

export default defineComponent({
  name: "ValidationProvider",
  components: { VeeValidationProvider },
  props: {
    rulesMessages: { type: Object, default: () => ({}) },
    validationMode: {
      type: String,
      validator: (value: string): boolean =>
        ["aggressive", "passive", "lazy", "eager", "aggressiveNotBlur"].includes(value) || value === undefined,
    },
    rules: {
      type: [Array, Object, String] as any as () => string[] | string | Record<string, any>,
      default: (): string[] => [],
    },
    name: { type: String, required: true },
  },
  setup(props, { emit }) {
    const validator = ref<InstanceType<typeof VeeValidationProvider>>();
    let unWatch: (() => void) | undefined;

    const aggressiveNotBlur = ({ errors }: { errors: any[] }) => {
      if (errors.length) {
        return {
          on: ["input", "change"],
        };
      }

      return {
        on: ["change", "input"],
      };
    };

    const mode = computed(() => {
      if (props.validationMode === "aggressiveNotBlur") {
        return aggressiveNotBlur;
      } else {
        return props.validationMode;
      }
    });

    onMounted(() => {
      unWatch = validator.value?.$watch(
        "flags.valid",
        newData => {
          emit("validation", newData);
        },
        {
          immediate: true,
        }
      );
    });
    onBeforeUnmount(() => unWatch && unWatch());

    return {
      validator,
      mode,
    };
  },
});
